// @flow
import type {
  UserOperator,
} from '../types'

// Constants
import { MODEL } from 'fc-model-users'

// Libs
import composeOperator from 'fc-operations'

// Exports
export const operator: UserOperator = composeOperator({
  model: MODEL,
})

export default operator
